const TEST_STRING = 'PXP Test Build';

export class PXPLaunchPadProps { }

export default function PXPLaunchPad() {
    return <div>{TEST_STRING}</div>
}

PXPLaunchPad.defaultProps = new PXPLaunchPadProps();
